import { useCallback, useEffect, useState } from "react";
import TableView from "../components/TableView";
import ProductTableAction from "../generatedTableActions/ProductTableAction";
import Button from "../components/Button";
import Badge from "../components/Badge";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../redux/store";
import {
    setCurrentPage,
    setPerPage,
    setLoading,
    setIcecat,
    setSearchTerm,
    setTotalPage,
    setTotalCount
} from "../generatedSlice/icecatSlice";


import useSearchApi from "../customHooks/useSearchApi";
// import { getProduct } from "../generatedRequest/product";
import { getIcecat, refuseAllIcecat, approveAllIcecat } from '../generatedRequest/icecatdata'
import { toast } from "react-toastify";
import TableSkeleton from "../components/TableSkeleton";

import { TTableProps } from "../types/TableView";
import TableLoader from "../utils/Loaders/tableLoader";
import { useNavigate } from "react-router-dom";
import { TOptionType } from "../types/CustomSelect";
// import ProductFilters from "../generatedFilters/ProductsFilters";
// import { getRegion } from "../app/request/regionRequest";
import UploadProductFormModal from "../generatedFormModal/UploadProductFormModal";
import { ActionCells } from "../components/ActionCells";
import { toAbsoluteUrl } from "../_metronic/helpers";
import IcecatList from "../generatedTableList/IcecatList";
import IcecatTableAction from "../generatedTableActions/IcecatTableAction";
import BrandFilter from "../components/Filters/BrandFilter";
import Swal from "sweetalert2";
// import MasterFormModal from "../generatedFormModal/MasterFormModal";

const actions = ["Manually", "Upload-Excel"];



const IcecatDataPage = () => {
    const dispatch = useDispatch();

    const [regionFilter, setRegionFilter] = useState("");
    const [categoryFilter, setCategoryFilter] = useState("");
    const [subcategoryFilter, setSubCategoryFilter] = useState("");
    const [allNewRegion, setAllNewRegion] = useState([]);
    const [initload, setInitload] = useState(true);
    const [filterloading, setFilterLoading] = useState(false)
    const [date, setDate] = useState([])
    const {
        data,
        perPage,
        currentPage,
        totalPage,
        searchTerm,
        loading,
        sortBy,
        sortColumn,
        rerender1,
        totalCount
    } = useSelector((state: RootState) => state.icecat);
    const [selectedRows, setSelectedRows] = useState<string[]>([]);

    const allIds = Array.isArray(data) ? data.map((item: any) => item._id) : [];

    const isAllSelected = selectedRows.length === allIds.length && allIds.length > 0;

    const [dateFilter, setDateFilter] = useState({ label: "All", value: "all" });
    const [brandFilter , setBrandFilter]:any = useState('')
    const [reloadPage, setReloadPage] = useState(false);



    const toggleSelectAll = () => {
        if (isAllSelected) {
            setSelectedRows([]);
        } else {
            setSelectedRows(allIds);
        }
    };

    const toggleRow = (id: string) => {
        setSelectedRows(prev =>
            prev.includes(id)
                ? prev.filter(rowId => rowId !== id)
                : [...prev, id]

        );
    };



useEffect(() => {
    const selectedRowsData = data.filter((item: any) => selectedRows.includes(item._id));
}, [selectedRows, data]);




const handleApproveAll = () => {
    if (selectedRows.length === 0) {
         Swal.fire({
            title: "No Products Selected",
            text: "Please select at least one product to approve.",
            icon: "warning",
            confirmButtonText: "OK"
        });
        return;
    }

    Swal.fire({
        title: "",
        text: "Are you sure you want to be able to approve the selected records?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, approve them!"
    }).then((result) => {
        if (result.isConfirmed) {
            approveAllIcecat({ ids: selectedRows })
            .then((response) => {
                if (response.data.status) {
                    toast.success("All selected products have been successfully approved.");
                    setSelectedRows([]);
                    setReloadPage(true)
                } else {
                    toast.error("Failed to approve selected products.");
                }
            })
            .catch((error) => {
                console.error("Error approving products:", error);
                toast.error("An error occurred while approving products.");
            });
        }
    }); 
  
};

const handleRemoveAll = () => {
    
    if (selectedRows.length === 0) {
         Swal.fire({
            title: "No Products Selected",
            text: "Please select at least one product to refuse.",
            icon: "warning",
            confirmButtonText: "OK"
        });
        return;
    }

    Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, refuse them!"
    }).then((result) => {
        if (result.isConfirmed) {
            refuseAllIcecat({ ids: selectedRows })
            .then((response) => {
                if (response.data.status) {
                    toast.success("All selected products have been refused successfully.");
                    setSelectedRows([]);
                    setReloadPage(true)
                } else {
                    toast.error("Failed to refuse selected products.");
                }
            })
            .catch((error) => {
                console.error("Error refusing products:", error);
                toast.error("An error occurred while refusing products.");
            });
        }
    });  
};
const getDateFilterOptions = () => {

    const defaultOptions = [
        { label: "All", value: "all" },

    ];


    const dateOptions = date.map(dateStr => ({
        label: dateStr,
        value: dateStr
    }));

    return [...defaultOptions, ...dateOptions];
};




    const columns = [
        {
            name: "id",
            renderHeader: () => (
                <div className='form-check form-check-custom'>
                    <input
                        className='form-check-input'
                        type='checkbox'
                        data-kt-check={''}
                        onChange={toggleSelectAll}
                        checked={isAllSelected}
                        style={{ margin: "0 3px" }}
                    />
                </div>
            ),
            renderCell: (row: any) => (
                <div className='form-check form-check-custom'>
                    <input
                        className='form-check-input'
                        type='checkbox'
                        data-kt-check={''}
                        style={{ margin: "0 3px" }}
                        checked={selectedRows.includes(row._id)}
                        onChange={() => toggleRow(row._id)}
                    />
                </div>
            ),
        },

        {
            name: "name",
            renderHeader: (rows: any) => (
                <>
                    <b>Name</b>
                </>
            ),
            renderCell: (row: any) => {
                const text = row?.productName || row?.description || "";
                const wordsArray = text.split(" ");
                const words = wordsArray.slice(0, 10).join(" ");
                return <>{words}{wordsArray.length > 10 ? "..." : ""}</>;
            }
        },

        {
            name: "brand",
            renderHeader: (rows: any) => (
                <>
                    <b>Brand</b>
                </>
            ),
            renderCell: (row: any) => <>{row && row.brand}</>,
        },


         {
            name: "subcategory",
            renderHeader: (rows: any) => (
                <>
                    <b>Subcategory</b>
                </>
            ),
            renderCell: (row: any) => <>{row && row.subcategoryName}</>,
        },


        {
            name: "status",
            renderHeader: (rows: any) => (
                <>
                    <b>Status</b>
                </>
            ),
            renderCell: (row: any) => (
                <Badge
                    variant={row.status == "active" ? "success" : "danger"}
                    className="fs-7 fw-bolder"
                >
                    {row.status}
                </Badge>
            )
        },
        // {
        //     name: "subcategory",
        //     renderHeader: (rows: any) => (
        //         <>
        //             <b>Subcategory</b>
        //         </>
        //     ),
        //     renderCell: (row: any) => <>{row?.subcategory?.subcategoryName}</>,
        // },

        {
            name: "created_at",
            renderHeader: (rows: any) => (
                <>
                    <b>Created At</b>
                </>
            ),
            renderCell: (row: any) => <>{row.createdAt}</>,
        },
        // {
        //     name: "modified_at",
        //     renderHeader: (rows: any) => (
        //         <>
        //             <b>Modified At</b>
        //         </>
        //     ),
        //     renderCell: (row: any) => <>{row.updatedAt}</>,
        // },
        {
            name: "Actions",
            renderHeader: (rows: any) => (
                <>
                    <b>Actions</b>
                </>
            ),
            renderCell: (row: any) => <IcecatTableAction Icecatproduct={row} />,
        },
    ];

    //   useEffect(() => {
    //     const fn = async () => {
    //       try {
    //         const response = await getRegion(`page=1&limit=100`);
    //         if (response.data.status) {
    //           setAllNewRegion(response.data.data.data);
    //         } else {
    //           toast.error("Something went wrong");
    //         }
    //       } catch (error) {
    //         toast.error("Network Error");
    //       } finally {
    //       }
    //     };
    //     fn();
    //   }, []);

    const handleDateFilterChange = useCallback((option: any) => {
        setDateFilter(option);
        setFilterLoading(true);
        dispatch(setCurrentPage(1));
        // Logic to apply date filter would go here in a real implementation
    }, [dispatch]);



    useEffect(() => {
        const fn = async () => {
            // Include dateFilter in the search query if it's not "all"
            const dateQueryParam = dateFilter.value !== "all" ? `&date=${dateFilter.value}` : "";
            const searchQuery = `page=${currentPage}&limit=${perPage}&search=${searchTerm}${dateQueryParam}&brand=${brandFilter}`;

            dispatch(setLoading(true));
            try {
                const response = await getIcecat(searchQuery);

                if (response.data.status) {
                    setDate(response.data.data.uniqueCreatedDates)
                }
                if (response.data.status) {
                    dispatch(setIcecat(response.data.data.data));
                     dispatch(setTotalCount(Math.ceil(response.data.data.totalCount)))
                    dispatch(
                        setTotalPage(Math.ceil(response.data.data.totalCount / perPage))
                    );
                } else {
                    toast.error("Something went wrong");
                }
            } catch (error) {
                toast.error("Network Error");
            } finally {
                dispatch(setLoading(false));
                setInitload(false);
                if (filterloading) {
                    setFilterLoading(false)
                }
            }
        };
        fn();
    }, [rerender1, dispatch, regionFilter, categoryFilter, subcategoryFilter, dateFilter, currentPage, perPage, searchTerm, brandFilter, reloadPage]);


    useEffect(() => {
        return () => {
            dispatch(setSearchTerm(''));
        };
    }, []);



    function handleAfterSearch(isSuceess: boolean, data: any, value: any) {
        if (isSuceess) {
            dispatch(setIcecat(data.data.data.data));
            dispatch(setTotalPage(Math.ceil(data.data.data.totalCount / value)));
        }
    }
    const { doSearch, searchLoading } = useSearchApi(
        getIcecat,
        handleAfterSearch
    );

    const handlePageChange = useCallback(
        (value: number) => {
            dispatch(setCurrentPage(value));
            // Include dateFilter in the search query
            const dateQueryParam = dateFilter.value !== "all" ? `&date=${dateFilter.value}` : "";

            const searchQuery = `page=${currentPage}&limit=${perPage}&search=${searchTerm}${dateQueryParam}&brand=${brandFilter}`;
            doSearch(searchQuery, perPage);
        },
        [dispatch, perPage, searchTerm, doSearch, dateFilter]
    );

    const handlePerPageChange = useCallback(
        (value: number) => {
            dispatch(setPerPage(value));
            // Include dateFilter in the search query
            const dateQueryParam = dateFilter.value !== "all" ? `&date=${dateFilter.value}` : "";
            const searchQuery = `page=${currentPage}&limit=${perPage}&search=${searchTerm}${dateQueryParam}&brand=${brandFilter}`;
            doSearch(searchQuery, value);
        },
        [dispatch, currentPage, searchTerm, doSearch, dateFilter]
    );

    const handleSearchParams = useCallback(
        (value: string) => {
            dispatch(setCurrentPage(1));
            dispatch(setSearchTerm(value));
            // Include dateFilter in the search query
            const dateQueryParam = dateFilter.value !== "all" ? `&date=${dateFilter.value}` : "";
            const searchQuery = `page=${"1"}&limit=${perPage}${dateQueryParam}&brand=${brandFilter}`;
            doSearch(searchQuery, perPage);
        },
        [perPage, dispatch, doSearch, dateFilter]
    );

    const handleBrandFilter = useCallback(
        (data: any) => {
          let payload = data.map((value: any) => value.brandName).join(",");
          dispatch(setCurrentPage(1))
          setBrandFilter(payload)
          setFilterLoading(true)
        },
        [perPage , dispatch , doSearch],
    );


     const dateFilterOptions = getDateFilterOptions();

    const configuration: TTableProps = {
        columns: columns,
        data: data,

        rows: data,
        showPagination: true,
        showSearch: true,
        showPerPage: true,
        paginationData: {
            perPage: perPage,
            currentPage: currentPage,
            totalPage: totalPage,
            totalCount: totalCount
        },
        showFilter: true,
        filters: (
            <>
                <BrandFilter
                    isAccesory={false}
                    onBrandFilterChange={handleBrandFilter}
                    currentBrandFilter={brandFilter}
                />
                <div className="date-filter-container d-flex align-items-center">
                    <div className="input-group input-group-md">
                        <span className="input-group-text bg-primary ">
                            <i className="bi bi-calendar3 text-light"></i>
                        </span>
                        <select
                            className="form-select form-select-solid"
                            value={dateFilter.value}
                            onChange={(e) => {
                                const selectedOption = dateFilterOptions.find(
                                    option => option.value === e.target.value
                                );
                                if (selectedOption) {
                                    handleDateFilterChange(selectedOption);
                                }
                            }}
                            style={{ minWidth: "140px" }}
                        >
                            {dateFilterOptions.map((option) => (
                                <option key={option.value} value={option.value}>
                                    {option.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </>),
        onPageChange: handlePageChange,
        onPerPageChange: handlePerPageChange,
        handleSearchParams: handleSearchParams,
        searchPlaceholder: "Search Products",
        searchLoading: searchLoading || filterloading,
    };

    const navigate = useNavigate();

    if (loading && initload) {
        return <TableSkeleton rows={10} columns={6} />;
    }

   


    return (
        <>
            <div className="d-flex justify-content-between align-items-center mb-5">
                <div className="d-flex align-items-center" style={{ gap: "5px" }}>
                    <h2>Icecat Products </h2>
                    <img
                        alt="Logo"
                        src={toAbsoluteUrl("/media/icons/duotune/art/exclamation-icon.svg")}
                        className="h-20px cursor-pointer"
                        onClick={() => navigate(`/helps?moduleName=Product`)}

                    />

                </div>



                <div className="d-flex gap-5">
                    
                    <Button variant="primary" size="medium" handleButtonClick={handleApproveAll}>
                        Approve All
                    </Button>

                    <Button variant="primary" size="medium" handleButtonClick={handleRemoveAll}>
                        Refuse All
                    </Button>
                </div>


                {/* <Button
          variant="primary"
          size="medium"
          handleButtonClick={() => navigate("add")}
        >
          Add Product
        </Button> */}



                {/* <ActionCells
          actions={actions}
          onSelect={handleSelect}
          title={"Add Product"}
          buttonStyle={`btn btn-light btn-primary btn-xl`}
          iconStyle={`svg-icon-4 ms-1`}
        /> */}
            </div>

            <IcecatList {...configuration} />
            {/* {uploadExcel && (
        <UploadProductFormModal onClose={() => handleUpload()} />
      )} */}


            {/* {addMasterModel && (
        <MasterFormModal onClose={() => handleMasterAdd()} />
      )} */}
        </>
    );
};

export default IcecatDataPage;
